import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

/**
 * Reusable empty state: icon, heading, copy, and primary CTA.
 * @param {string} icon - Font Awesome icon class (e.g. "fa-solid fa-folder-open")
 * @param {string} heading - Short heading (e.g. "No sites yet")
 * @param {string} copy - One line of copy
 * @param {string} [buttonLabel] - Primary button label (e.g. "Add your first site")
 * @param {string} [buttonTo] - React Router path for the button (e.g. "/addsite")
 */
function EmptyState({ icon = "fa-solid fa-folder-open", heading = "Nothing here yet", copy, buttonLabel, buttonTo }) {
  return (
    <div className="empty-state text-center py-5 px-3" role="status" aria-live="polite">
      <div className="empty-state__icon text-muted mb-3">
        <i className={`fa-3x ${icon}`} aria-hidden="true" />
      </div>
      <h5 className="empty-state__heading mb-2">{heading}</h5>
      {copy && <p className="empty-state__copy text-muted mb-4">{copy}</p>}
      {buttonLabel && buttonTo && (
        <Link to={buttonTo}>
          <Button variant="primary" size="lg" className="empty-state__cta">
            {buttonLabel}
          </Button>
        </Link>
      )}
    </div>
  );
}

export default EmptyState;
